/* tslint:disable */
/* eslint-disable */
/**
 * Melco Assets APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssetsMelcoAssetsModelsAlphabetCategoryItem
 */
export interface AssetsMelcoAssetsModelsAlphabetCategoryItem {
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoAssetsModelsAlphabetCategoryItem
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoAssetsModelsAlphabetCategoryItem
     */
    name?: string | null;
}

export function AssetsMelcoAssetsModelsAlphabetCategoryItemFromJSON(json: any): AssetsMelcoAssetsModelsAlphabetCategoryItem {
    return AssetsMelcoAssetsModelsAlphabetCategoryItemFromJSONTyped(json, false);
}

export function AssetsMelcoAssetsModelsAlphabetCategoryItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetsMelcoAssetsModelsAlphabetCategoryItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function AssetsMelcoAssetsModelsAlphabetCategoryItemToJSON(value?: AssetsMelcoAssetsModelsAlphabetCategoryItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}


